module.exports = __webpack_public_path__ + "img/home.43698584.svg";